<template>
    <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
        <a-card style="" :bordered="true" :title="$t('数据详情')">
            <detail-list :col="2" v-if="!!model.meterIdList">
                <a-textarea v-model="model.meterIdList" placeholder="..." :rows="3" style="width:100%;" disabled />
            </detail-list>
            <detail-list :col="2" v-else>
                <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
                <detail-list-item term="ST1/ST2">
                  <template v-if="model.meterType == '80'&&model.meterStatus3!=null">
                    0x{{model.meterStatus3.toString(16)}}
                  </template>
                  <template v-else-if="model.meterType == '18'&&model.meterStatus2!=null">
                    0x{{model.meterStatus2.toString(16)}}
                  </template>
                </detail-list-item>
                <detail-list-item :term="$t('告警时间')">{{model.updateTime}}</detail-list-item>
                <div v-if="model.meterType == '80'&&model.meterStatus3!=null">
                <a-col :span="6" style="margin-bttom: 16px">
                  <span>bit7: {{(model.meterStatus3&128)!== 0?1:0}}(NRST:{{(model.meterStatus3&128)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit6: {{(model.meterStatus3&64)!== 0?1:0}}(css:{{(model.meterStatus3&64)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit5: {{(model.meterStatus3&32)!== 0?1:0}}(lockup:{{(model.meterStatus3&32)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit4: {{(model.meterStatus3&16)!== 0?1:0}}(PCA:{{(model.meterStatus3&16)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit3: {{(model.meterStatus3&8)!== 0?1:0}}(WDT:{{(model.meterStatus3&8)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span >bit2: {{(model.meterStatus3&4)!== 0?1:0}}(LVD:{{(model.meterStatus3&4)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit1: {{(model.meterStatus3&2)!== 0?1:0}}(bit1:{{(model.meterStatus3&2)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit0: {{(model.meterStatus3&1)!== 0?1:0}}(bit0:{{(model.meterStatus3&1)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
              </div>
              <div v-else-if="model.meterType == '18'&&model.meterStatus2!=null">
                <a-col :span="6" style="margin-bttom: 16px">
                  <span>bit7: {{(model.meterStatus2&128)!== 0?1:0}}(NRST:{{(model.meterStatus2&128)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit6: {{(model.meterStatus2&64)!== 0?1:0}}(css:{{(model.meterStatus2&64)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit5: {{(model.meterStatus2&32)!== 0?1:0}}(BORF:{{(model.meterStatus2&32)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit4: {{(model.meterStatus2&16)!== 0?1:0}}({{ $t('HSI标准') }}:{{(model.meterStatus2&16)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit3: {{(model.meterStatus2&8)!== 0?1:0}}(IWDGF:{{(model.meterStatus2&8)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span >bit2: {{(model.meterStatus2&4)!== 0?1:0}}(LLOPF:{{(model.meterStatus2&4)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit1: {{(model.meterStatus2&2)!== 0?1:0}}(SWIMF:{{(model.meterStatus2&2)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
                <a-col :span="6" style="margin-bottom: 16px">
                <span>bit0: {{(model.meterStatus2&1)!== 0?1:0}}(PORF:{{(model.meterStatus2&1)!== 0?$t('有'):$t('无')}})</span>
                </a-col>
              </div>
            </detail-list>
            
        </a-card>
        <a-form-model ref="formModal" :model="formModel" :rules="rules" :colon="false">
            <a-row :gutter="48">
                <a-col :span="7">
                </a-col>
                <a-col :span="8">
                    <a-form-item :label="$t('处理状态')" prop="meterDealStatus">
                        <a-select v-model="formModel.meterDealStatus" :placeholder="$t('请选择处理状态')" type="primary">
                            <a-select-option :value="0">
                                {{ $t('未处理') }}
                            </a-select-option>
                            <a-select-option :value="1">
                                {{ $t('处理中') }}
                            </a-select-option>
                            <a-select-option :value="2">
                                {{ $t('已处理') }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="$t('处理描述')" prop="meterDealDescription">
                    <a-textarea v-model="formModel.meterDealDescription" :placeholder="$t('请输入处理描述')" :rows="3" style="width:100%;"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-spin>
    </a-modal>
</template>

<script>

  import { postAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  import {isUndefinedAndNull} from'@/utils/validate'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUseWarnRecordDealModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        model: {},
        meterTypeObj,
        netTypeObj,
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        formModel: {
            meterDealStatus: 0
        },
        url: {

          dealWarnRecord: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/updateMeterWarnRecord",
        }
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules() {
        return {
          meterDealStatus: [
              {required:true, message:this.$t('请选择处理状态')}
          ],
          meterDealDescription: [
              {required:true, message:this.$t('请输入处理描述')}
          ]
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(this.model.meterDealStatus) {
          this.formModel.meterDealStatus = this.model.meterDealStatus;
        }
        this.disableSubmit = true;
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.formModel = this.$options.data.call(this).formModel;
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = this.url.dealWarnRecord;
            let params = {...this.formModel}
            if(!!this.model.meterIdList) {
                // 批量处理
                params.idList = this.model.idList
            }else {
                // 单个处理
                params.meterId = this.model.meterId
            }
            params.meterWarnType = 4;
            if(this.formModel.meterDealStatus == 0) {
              params.meterDealDescription0 = params.meterDealDescription
            }else if(this.formModel.meterDealStatus == 1) {
              params.meterDealDescription1 = params.meterDealDescription
            }else if(this.formModel.meterDealStatus == 2) {
              params.meterDealDescription2 = params.meterDealDescription
            }
            postAction(httpurl,params).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>